import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../utils/api_instance.util";
import { errorToastify } from "../utils/toastify.util";

const initialState = {
    isLoader: false,
    dasboardCountData: null,
    revenueChartData: {
        labels: [],
        datasets: [],
    },
    userSubscriptionChartData: null,
    userSubscriptionLoader: false,

    subscriptionRevenue: null,
    subscriptionRevenueLoader: false,

    // ✅ NEW activity log state
    activityLogRows: [],
    activityLogTotal: 0,
    activityLogLimit: 10,
    activityLogOffset: 0,
    activityLogLoading: false,
    activityLogError: null,
};

export const getDashboardCount = createAsyncThunk(
    "dashboard/getDashboardCount",
    async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();

            Object.entries(params || {}).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                    queryParams.append(key, value);
                }
            });

            const queryString = queryParams.toString();
            const { data } = await instance.get(`/api/v1/admin/dashboard${queryString ? `?${queryString}` : ""}`);
            return data;
        } catch (err) {
            const { data } = err.response;
            errorToastify(data.message);
        }
    }
);

export const getUserSubscriptionData = createAsyncThunk(
    "dashboard/getUserSubscriptionData",
    async () => {
        try {
            const { data } = await instance.get(`/api/v1/admin/dashboard/user-subscription-count`);
            return data;
        } catch (err) {
            const { data } = err.response;
            errorToastify(data.message);
        }
    }
);

export const getMonthWiseSubscriptionRevenue = createAsyncThunk(
    "dashboard/getMonthWiseSubscriptionRevenue",
    async () => {
        try {
            const { data } = await instance.get(`/api/v1/admin/dashboard/revenue-by-plan`);
            return data;
        } catch (err) {
            const { data } = err.response;
            errorToastify(data.message);
        }
    }
);

// ✅ NEW thunk: Activity logs list
export const getActivityLogs = createAsyncThunk(
    "dashboard/getActivityLogs",
    async ({ limit = 10, offset = 0, searchText = "" }, { rejectWithValue }) => {
        try {
            const { data } = await instance.post(
                "/api/v1/admin/dashboard/activity-log/list",
                { limit, offset, searchText }
            );

            // expecting: data.response.rows, data.response.total, data.response.limit, data.response.offset
            return data;
        } catch (err) {
            return rejectWithValue(err?.response?.data || { message: "Something went wrong" });
        }
    }
);

const dashboardSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getDashboardCount.pending, (state, action) => {
            state.isLoader = true;
        });
        builder.addCase(getDashboardCount.fulfilled, (state, action) => {
            if (action.payload?.success || false) {
                state.isLoader = false;
                state.dasboardCountData = action.payload.result;
            } else {
                state.isLoader = false;
                state.dasboardCountData = null;
            }
        });

        builder.addCase(getUserSubscriptionData.pending, (state, action) => {
            state.userSubscriptionLoader = true;
        });
        builder.addCase(getUserSubscriptionData.fulfilled, (state, action) => {
            if (action.payload?.success || false) {
                state.userSubscriptionLoader = false;
                state.userSubscriptionChartData = action.payload.result;
            } else {
                state.userSubscriptionLoader = false;
                state.userSubscriptionChartData = null;
            }
        });

        builder.addCase(getMonthWiseSubscriptionRevenue.pending, (state, action) => {
            state.subscriptionRevenueLoader = true;
        });
        builder.addCase(getMonthWiseSubscriptionRevenue.fulfilled, (state, action) => {
            if (action.payload?.success || false) {
                state.subscriptionRevenueLoader = false;
                state.subscriptionRevenue = action.payload.result;
            } else {
                state.subscriptionRevenueLoader = false;
                state.subscriptionRevenue = null;
            }
        });


        builder
            .addCase(getActivityLogs.pending, (state) => {
                state.activityLogLoading = true;
                state.activityLogError = null;
            })
            .addCase(getActivityLogs.fulfilled, (state, action) => {
                state.activityLogLoading = false;

                const rows = action?.payload?.response?.rows || [];
                const total = Number(action?.payload?.response?.total || 0);
                const limit = Number(action?.payload?.response?.limit || state.activityLogLimit);
                const offset = Number(action?.payload?.response?.offset || state.activityLogOffset);

                state.activityLogRows = Array.isArray(rows) ? rows : [];
                state.activityLogTotal = total;
                state.activityLogLimit = limit;
                state.activityLogOffset = offset;
            })
            .addCase(getActivityLogs.rejected, (state, action) => {
                state.activityLogLoading = false;
                state.activityLogError = action?.payload?.message || "Failed to fetch activity logs";
                state.activityLogRows = [];
                state.activityLogTotal = 0;
            });
    },
})

export default dashboardSlice.reducer;
